import { CheckboxAnswer, TextAnswer } from './anwer-types';
import { useItem, useReport } from './hooks/use-context';
import { AnswerData, QuestionData } from './types';

export function InitialInfos() {
  const { sections } = useItem();
  const { header } = useReport();

  const questions = sections.flatMap((section) => section.questions);
  const involvedQuestion = questions.find(
    (question) =>
      question.question_id === '8eeffe91-e183-479a-8c37-dc28d61d8c3c',
  );
  const involvedQuestionText = questions.find(
    (question) =>
      question.question_id === 'd8d7239e-074f-4d6c-92d0-4289f6db2136',
  );

  return (
    <div
      style={{
        marginBottom: '20px',
        color: '#000',
      }}
    >
      <div
        style={{
          backgroundColor: '#E0F4E9',
          padding: '10px',
          borderRadius: '6px',
        }}
      >
        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                name: 'Cadastro:',
                answers:
                  involvedQuestion?.answers || involvedQuestionText?.answers
                    ? [
                        {
                          content: involvedQuestion?.answers
                            ? involvedQuestion?.answers
                                ?.map((answer) => answer.collection_item.code)
                                .join(', ')
                            : 'Externo',
                        } as AnswerData,
                      ]
                    : [],
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                name: 'Nome dos envolvidos(as):',
                answers:
                  involvedQuestion?.answers || involvedQuestionText?.answers
                    ? [
                        {
                          content: involvedQuestion?.answers
                            ? involvedQuestion?.answers
                                ?.map((answer) => answer.collection_item?.name)
                                .join(', ')
                                .concat(involvedQuestionText ? ' - ' : '')
                                .concat(
                                  involvedQuestionText?.answers?.[0].content ||
                                    '',
                                )
                            : involvedQuestionText?.answers?.[0].content,
                        } as AnswerData,
                      ]
                    : [],
              } as QuestionData
            }
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    '77f218ce-3115-4af7-a7af-79b1363a571c',
                ),
                name: 'Tempo na função:',
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    '3d6cfe12-c6ce-4db1-8f34-b45fc5d9f65a',
                ),
                name: 'Cargo/Área de Atuação:',
              } as QuestionData
            }
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                name: 'Data:',
                answers: [{ content: header.event_finished_at.split(' ')[0] }],
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                name: 'Horário:',
                answers: [{ content: header.event_finished_at.split(' ')[1] }],
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    '7427e6ac-2a41-49ec-979a-1ecb4ba0aaac',
                ),
                name: 'Local:',
              } as QuestionData
            }
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <CheckboxAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    'db762262-5ed0-403f-97b4-1424c1c87e98',
                ),
                name: 'Classificação da ocorrência:',
              } as QuestionData
            }
            options={[
              'Incidente',
              'Acidente sem Afastamento',
              'Acidente com Afastamento',
              'Acidente de Trajeto',
            ]}
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                name: 'TST responsável pela análise:',
                answers: [{ content: header.author_full_name } as AnswerData],
              } as QuestionData
            }
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFFFF',
            minHeight: '200px',
            width: '100%',
            padding: '6px 10px',
            borderRadius: '6px',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ marginBottom: '12px' }}>
            <div
              style={{
                marginBottom: '4px',
                color: 'GrayText',
                fontSize: '14px',
              }}
            >
              Descrição da Ocorrência:
            </div>
            <div>
              {
                questions.find(
                  (question) =>
                    question.question_id ===
                    '6e7d7e0f-b548-4da1-baee-16f1e4aa5233',
                )?.answers?.[0]?.content
              }
            </div>
          </div>
          <div>
            <h3
              style={{
                marginBottom: '4px',
                color: 'GrayText',
                fontSize: '14px',
              }}
            >
              Perigos:
            </h3>
            <div>
              {sections
                .flatMap((section) => section.questions)
                .find(
                  (question) =>
                    question.question_id ===
                    '9f956dce-e9f6-4d88-9f14-b744a11058a4',
                )
                ?.answers?.map((answer) => (
                  <div>{answer.option}</div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
